import { render, staticRenderFns } from "./item_cart_order.vue?vue&type=template&id=fb09b5c4&"
import script from "./item_cart_order.vue?vue&type=script&lang=js&"
export * from "./item_cart_order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports